<template>
  <div class="background-wrapper" v-if="experienceData">
    <div class="intro_content container">
      <v-col cols="12">
        <h1
          class="text-light anim-title mg-0 intro__title heading-one is-shown"
        >
          {{ experienceData.expCat_tagline }}
        </h1>
        <div class="video-container intro__video">
          <v-col class="col-md-8 offset-md-2">
            <div id="video-wrapper" class="video-teaser is-playing">
              <video
                width="100%"
                height="200px"
                id="vid"
                controls
                loop
                autoplay
                muted
                v-show="experienceData.expVideo"
              >
                <source :src="`${experienceData.expVideo}`" type="video/mp4" />
              </video>
              <!-- <iframe
                class="video-teaser"
                :src="`${experienceData.expVideo}`"
                loop
                frameborder="0"
                allowfullscreen
                v-show="experienceData.expVideo"
              ></iframe> -->
              <!-- <video width="450" controls>
                <source src="../src/assets/static/videos/videoplayback_Rebula_edi-simcic.mp4" type="video/mp4">
              </video> -->
            </div>
          </v-col>
        </div>
        <v-spacer></v-spacer>
      </v-col>
      <div id="cta-sticky">
        <div style="width: 100%; margin-top: 5px;">
          <b-button class="cta-button" @click="sendUserToReservationLink()"
            >CHECK AVAILABILITY</b-button>
        </div>
      </div>
    </div>
    <v-row class="product-info">
      <v-col>
        <h1 class="product_title">{{ experienceData.expName }}</h1>
        <v-card class="d-inline-block mx-auto">
          <v-container>
            <v-row justify="space-between">
              <v-col cols="auto">
                <img
                  :src="`${experienceData.expImage}`"
                  height="200"
                  width="200"
                  :alt="experienceData.expName"
                />
              </v-col>
              <v-col cols="auto" class="text-center pl-0">
                <v-row class="flex-column ma-0 fill-height" justify="center">
                  <!--ADD TO WISHLIST ICON TEMPORARY REMOVED
                    <v-col class="px-0">
                      <v-btn icon>
                        <v-icon>mdi-heart</v-icon>
                      </v-btn>
                    </v-col>¸  -->
                  <!--SHARE ICON TEMPORARY REMOVED
                    <v-col class="px-0">
                      <v-btn icon>
                        <v-icon>mdi-share-variant</v-icon>
                      </v-btn>
                    </v-col> -->
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
        <div
          class="description_text"
          data-aos="fade-up"
          data-aos-anchor-placement="center-bottom"
        >
          <p>{{ experienceData.expDescription }}</p>
        </div>
        <v-spacer></v-spacer>
      </v-col>
    </v-row>
    <v-row class="price-section">
      <v-col>
        <v-col class="price-details">
          <span class="price">
            {{ experienceData.priceMIN }} - {{ experienceData.priceMAX }}
          </span>
          <span class="valuta">EUR</span>
          <div class="tax-details">(incl. of all taxes and fees)</div>
        </v-col>
        <v-spacer></v-spacer>
        <span class="promo-code">
          PROMO CODE: EXPAR{{ experienceData.clientId }}
        </span>
        <!-- <b-button class="cta-button" @click="sendUserToReservationLink()"
          >CHECK AVAILABILITY</b-button> -->
      </v-col>
    </v-row>
    <!--end of Multiple modal-->
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      experienceData: null,
      baseUrl: process.env.VUE_APP_API_URL,
    }
  },
  methods: {
    sendUserToReservationLink() {
      window.open(this.experienceData.url, '_blank')
    },
  },
  async mounted() {
    await axios
      .get(
        `${process.env.VUE_APP_API_URL}/unitStore/unit/${this.$route.params.unitUUID}/experience/${this.$route.params.experienceUUID}`
      )
      .then((response) => {
        this.experienceData = response.data
      })
      .catch((error) => {
        console.log(error)
        this.errored = true
      })
      .finally(() => (this.loading = false))
    // await this.$store.dispatch('addToCart', this.createCartItemBody())
    // this.cartData = await this.$store.dispatch('getFromCart')
  },
}
</script>

<style lang="scss" scoped>
*,
*:before,
*:after {
  box-sizing: inherit;
}

html {
  font-size: 14px;
  box-sizing: border-box;
}

body {
  margin: 0;
}

h1 {
  margin: 0;
  font-size: 1.8em;
}

p {
  color: var(--bg);
}

hr {
  height: 1px;
  width: 100%;
  background-color: var(--grey);
  border: 0;
  margin: 1.5rem 0;
}

.container {
  max-width: 40rem;
  padding: 2vw 0.5rem 0;
  margin: 0 auto;
  height: auto;
}

.form {
  display: grid;
  grid-gap: 1rem;
}

.field {
  width: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--grey-superlight);
  padding: 0.5rem;
  border-radius: 0.25rem;
}

.field__label {
  color: var(--gray);
  font-size: 0.6rem;
  font-weight: 300;
  text-transform: uppercase;
  text-align: left;
}

.field__input {
  padding: 0;
  margin: 0;
  border: 0;
  outline: 0;
  font-weight: bold;
  font-size: 1rem;
  width: 100%;
  -webkit-appearance: none;
  appearance: none;
  background-color: var(--grey-superlight);
}
.field:focus-within {
  border-color: #000;
}

.fields {
  display: grid;
  grid-gap: 1rem;
}
.fields--2 {
  grid-template-columns: 1fr 1fr;
}
.fields--3 {
  grid-template-columns: 1fr 2fr;
}

.button {
  background: linear-gradient(to right, #fb7377, #c95c5f);
  text-transform: uppercase;
  font-size: 0.8rem;
  font-weight: 600;
  display: block;
  color: #fff;
  width: 100%;
  padding: 1rem;
  border-radius: 0.25rem;
  border: 0;
  cursor: pointer;
  outline: 0;
}
.button:focus-visible {
  background-color: var(--bg);
}

.errorMessage {
  font-size: 0.8em;
  margin-top: -10px;
  color: var(--primaryDark);
  display: flex;
}

.trashIcon {
  background: var(--gray);
  color: var(--bright) !important;
  padding: 10px !important;
  border: none !important;
  border-radius: 3.5px;
  width: 40px;
  height: 40px;
  margin-left: 10px;
  display: inline;
  margin-top: 3px;
  position: absolute;
}

.trashIcon:active {
  background: var(--bg);
}

.left {
  text-align: left;
  font-size: 0.85em;
  margin-bottom: 2em;
}
.totalPriceLeft {
  text-align: left;
  margin-left: 30px;
}
.totalPrice {
  font-size: 2.3rem;
  font-weight: 600;
}
.totalPrice2 {
  font-size: 0.8rem;
  font-weight: 600;
}

.background-wrapper {
  scroll-behavior: smooth;
}
.stock-info-text {
  color: white;
}
.stock-info-text-cart {
  color: black;
}
.shipping-info {
  color: black;
  display: block;
}
.colorLink {
  color: var(--bg) !important;
}
.colorLink:hover {
  color: var(--primary) !important;
}
.colorLink:active {
  color: var(--primary) !important;
}
#scroll {
  position: fixed;
  background: #373a47;
  padding: 5px;
  border-radius: 3px;
  bottom: 80px;
  right: 40px;
  text-align: center;
  z-index: 2000;
  color: #fafbfc;
}
#cta-sticky {
  position: fixed;
  background-color: $primary-dark;
  width: 100%;
  height: 70px;
  text-align: center;
  z-index: 250;
  bottom: 0px;
}
// .rating {
//   text-align: left;
//   padding-left: 40px;
// }
.ratingNo {
  font-size: 25px;
  font-weight: 600;
}
.description_text {
  padding: 30px;
  text-align: justify;
}
.price-details {
  padding-left: 50px;
  padding-bottom: 30px;
  text-align: left;
}
.price {
  font-size: 40px;
  font-weight: 700;
}
.promo-code {
  font-size: 20px;
  font-weight: 700;
  display: inherit;
}
.valuta {
  font-size: 27px;
  font-weight: 700;
}
.tax-details {
  font-size: 12px;
  font-weight: 400;
}
.secondary-gradient {
  background-color: linear-gradient(
    200deg,
    rgba(203, 108, 0, 1) 29% rgba(247, 144, 30, 1) 59
  );
}
.myBagImg {
  max-width: 140px;
}
.media {
  margin-bottom: 2em;
}
.disclaimer {
  position: relative;
}
.notShippable {
  width: 100% !important; // width: 100%; when product is NOT shippable !!!! //
}
.scanBuy {
  float: left;
  width: 50%;
}
.shipTo {
  float: right;
  width: 35%;
}
.secondary-gradient {
  width: 80%;
}
.product_title {
  font-size: 35px;
  font-weight: 100;
  text-transform: uppercase;
}

.stripeIcon {
  width: 100%;
  max-width: 150px;
}
.stripeCards {
  width: 90%;
  margin: 10px;
}
.stripeTrustBadge {
  margin-top: 40px;
  color: #32364e;
}

.divider {
  margin-bottom: 20px;
  margin-top: 20px;
  margin-left: 20px;
  margin-right: 20px;
}

.intro_content {
  margin-top: -15rem;
  z-index: 0;
}
.container {
  max-width: 100%;
  width: 100%;
  padding-right: 0rem;
  padding-left: 0rem;
  margin-right: auto;
  margin-left: auto;
}
.intro__title {
  position: relative;
  z-index: 110;
}
.heading-one {
  font-size: 4rem;
}
.text-light {
  color: #fff !important;
  line-height: 100%;
}
.mb-0 {
  margin-bottom: 0 !important;
}
.intro__video {
  margin-top: -2rem;
}
.video-container {
  display: -webkit-box;
  display: flex;
  flex-wrap: wrap;
  margin-right: 0px;
  margin-left: 0px;
}
.video-teaser {
  position: relative;
  cursor: pointer;
  z-index: 100;
  height: 200px;
  width: 100%;
}

::v-deep .hide-padding {
  padding: 0;
}

form {
  width: 300px;
  margin: 0 auto;
  text-align: center;
  padding-top: 20px;
  margin-bottom: 2em;
}

.value-button {
  display: inline-block;
  border: 1px solid #ddd;
  margin: 0px;
  width: 40px;
  text-align: center;
  vertical-align: middle;
  padding: 11px 0;
  background: #eee;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.value-button:hover {
  cursor: pointer;
}

form #decrease {
  margin-right: -4px;
  border-radius: 8px 0 0 8px;
}

form #increase {
  margin-left: -4px;
  border-radius: 0 8px 8px 0;
}

form #input-wrap {
  margin: 0px;
  padding: 0px;
}

input#number {
  text-align: center;
  border: none;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  margin: 0px;
  width: 40px;
  height: 40px;
}

input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

//CTA button css //
.cta-button {
  background: linear-gradient(to right, var(--primary),var(--darkPrimary));
  width: 310px;
  color: white;
  margin-top: 5px;
  margin-bottom: 50px;
  align-items: center;
  justify-content: space-between;
  height: 52px;
  border: none;
  border-radius: 5px;
  font-size: 1.4em;
  text-align: center;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  font-weight: 500;
  white-space: nowrap;
  transition: all 0.2s linear;
}

.cta-button:hover {
  transform: scale(1);
  box-shadow: none;
  background: linear-gradient(to right, #f7921ec9, #c46428a8);
}

.cta-button:active {
  animation: pulse 0.25s infinite ease-out;
}

.cta-button:focus {
  outline: 0;
}
.cta-button:disabled {
  -webkit-transform: scale(1);
  transform: scale(1);
  box-shadow: none;
}

@keyframes pulse {
  0% {
    transform: scale(0.9);
  }
  40% {
    transform: scale(1);
  }
  80% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.9);
  }
}

.logout_btn {
  padding: 15px;
  background: var(--bg-light);
  text-decoration: none;
  margin-top: -30px;
  border-radius: 7px;
  font-size: 16px;
  font-weight: 100;
  color: var(--white);
  transition: 0.5s;
  transition-property: background;
  letter-spacing: 1px;
}

.logout_btn:hover {
  background: #49535e;
}
//----end of CTA buton --//

.about-img2 {
  display: inline-block;
  width: 100%;
  margin-top: -20px;
  max-width: 250px;
  text-align: center;
  vertical-align: top;
}

// media queries for common device breakpoints

//Galaxy Fold //
@media only screen and (min-device-width: 270px) and (max-device-width: 280px) {
  .intro_content {
    margin-top: -18rem;
  }
  .heading-one {
    font-size: 2.4em;
  }
}
//
@media only screen and (min-device-width: 281px) and (max-device-width: 320px) {
  .intro_content {
    margin-top: -22rem;
  }
  .heading-one {
    font-size: 2.6em;
  }
}
//iPhone 5 //
@media only screen and (min-device-width: 321px) and (max-device-width: 359px) and (orientation: portrait) {
  .intro_content {
    margin-top: -30rem;
  }
  .product_title {
    padding: 0 20px;
  }
}
@media only screen and (min-device-width: 320px) and (max-device-width: 568px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
  .intro_content {
    margin-top: -25rem;
  }
  .heading-one {
    font-size: 2.5em;
  }
  .product-info {
    margin-top: 18rem;
  }
  .description_text {
    padding: 30px 60px;
  }
  .product_title {
    padding: 0 50px;
  }
}
//Galaxy S5/S8/Moto S4  and Note 3//
@media only screen and (min-device-width: 360px) and (max-device-width: 374px) and (orientation: portrait) {
  .intro_content {
    margin-top: -20rem;
  }
  .heading-one {
    font-size: 3em;
  }
  .product_title {
    padding: 0 17px;
  }
}
@media screen and (device-width: 320px) and (device-height: 640px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape) {
  .intro_content {
    margin-top: -26rem;
  }
  .heading-one {
    font-size: 3.5em;
  }
  .product-info {
    margin-top: 10rem;
  }
  .description_text {
    padding: 30px 100px;
  }
  .product_title {
    padding: 0 50px;
  }
  .video-teaser {
    left: 5px;
  }
}

//iPhone 6/7/8/X/11Pro/12 Mini //
@media only screen and (min-device-width: 375px) and (max-device-width: 389px) and (orientation: portrait) {
  .intro_content {
    margin-top: -18rem;
  }
  .heading-one {
    font-size: 3.2em;
  }
  .product_title {
    padding: 0 20px;
  }
}
@media only screen and (min-device-width: 375px) and (max-device-width: 812px) and (-webkit-min-device-pixel-ratio: 3) and (orientation: landscape) {
  .intro_content {
    margin-top: -23rem;
  }
  .heading-one {
    font-size: 3.5em;
  }
  .product-info {
    margin-top: 25rem;
  }
  .description_text {
    padding: 30px 130px;
  }
  .product_title {
    padding: 0 50px;
  }
  .video-teaser {
    left: -30px;
  }
}
//iPhone 12/12Pro //
@media only screen and (min-device-width: 390px) and (max-device-width: 413px) and (orientation: portrait) {
  .intro_content {
    margin-top: -20rem;
  }
  .heading-one {
    font-size: 3.4em;
  }
}
//iPhone 6/7/8 Plus/11 //
@media only screen and (min-device-width: 414px) and (max-device-width: 440px) and (orientation: portrait) {
  .intro_content {
    margin-top: -16rem;
  }
  .heading-one {
    font-size: 3.6em;
  }
  .product_title {
    padding: 0 20px;
  }
}
@media only screen and (min-device-width: 414px) and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 3) and (orientation: landscape) {
  .intro_content {
    margin-top: -23rem;
  }
  .heading-one {
    font-size: 3.5em;
  }
  .product-info {
    margin-top: 25rem;
  }
  .description_text {
    padding: 30px 130px;
  }
  .product_title {
    padding: 0 50px;
  }
  .video-teaser {
    left: 0px;
  }
}

//  CSS media queries to target Apple's 2019 and 2020 devices

// iPhone 12 Mini, iPhone 11 Pro, iPhone Xs, and iPhone X
// @media only screen
//     and (device-width: 375px)
//     and (device-height: 812px)
//     and (-webkit-device-pixel-ratio: 3) { }

// iPhone 12 and iPhone 12 Pro
// @media only screen
//     and (device-width: 390px)
//     and (device-height: 844px)
//     and (-webkit-device-pixel-ratio: 3) { }

// iPhone 12 Pro Max
// @media only screen
//     and (device-width: 428px)
//     and (device-height: 926px)
//     and (-webkit-device-pixel-ratio: 3) { }

// iPhone 11 and iPhone XR
// @media only screen
//     and (device-width: 414px)
//     and (device-height: 896px)
//     and (-webkit-device-pixel-ratio: 2) { }

//  iPhone 12 Mini, iPhone 11 Pro, iPhone Xs, and iPhone X
//  @media only screen
//     and (device-width: 375px)
//     and (device-height: 812px)
//     and (-webkit-device-pixel-ratio: 3) { }

// iPhone 11 Pro Max and iPhone Xs Max
// @media only screen
//     and (device-width: 414px)
//     and (device-height: 896px)
//     and (-webkit-device-pixel-ratio: 3) { }
</style>
